import { shallowEqual } from 'react-redux';

import { TBackofficeGroupResourceCountsEndpoint } from '@/backoffice/features/groups/hooks/use-backoffice-groups-resources-count.types';
import { backofficeApi } from '@/backoffice/redux/api/backoffice/backoffice-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

const readBackofficeGroupResourceCountsEndpoint = backofficeApi.endpoints[
  'ReadBackofficeGroupResourceCounts' as keyof typeof backofficeApi.endpoints
] as TBackofficeGroupResourceCountsEndpoint;

// Reads cached per-group counts (from the tree badges) to block deleting non-empty groups.
export const useBackofficeGroupsResourcesCount = (groupIds: string[]) =>
  useAppSelector(
    (state) =>
      Object.fromEntries(
        groupIds.map((groupId) => {
          const { data, isLoading } =
            readBackofficeGroupResourceCountsEndpoint.select({
              groupId,
            })(state);

          const allResourcesCount =
            (data?.readBackofficeResourceGroup.subGroups.itemCount ?? 0) +
            (data?.readBackofficeResourceGroup.tenants.itemCount ?? 0) +
            (data?.groupUsers.itemCount ?? 0) +
            (data?.groupRoles.itemCount ?? 0);

          return [groupId, { allResourcesCount, isLoading }];
        }),
      ),
    shallowEqual,
  );
